import * as React from 'react';
import Avatar from './Avatar';
import Icon from 'common/components/IconFont';
import * as intl from "react-intl-universal";

interface iConfig {
    children?: Array<{
        key: string;
        href: string;
    }>;
    signOut?: Function;
    totalCounts?: number;
    icons?: any;
    uuid?: string;
    copy?: (uuid: string) => void;
}

const IconMap: { [key: string]: string } = {
    'PERSONAL_INFO_PROFILE': 'customer_management',
    'SETTING_SIGN_OUT': 'drop_out',
    'COPY_UUID': 'copy'
};

export default ({ signOut, uuid, copy }: iConfig) => ({
    key: 'accout-menu',
    title: <Avatar showUser={false} />,
    children: [{
        key: 'userInfo',
        path: '',
        title: <Avatar showUser={true} />
    }, {
        key: 'COPY_UUID',
        path: '',
        title: <a className='account-uuid' onClick={() => copy(uuid)}>
            <dl>
                <dt>ID</dt>
                <dd>{uuid}<Icon style={{ fontSize: "14px", marginBottom: "2px" }}
                    className={`anticon-${IconMap['COPY_UUID']}`} /></dd>
            </dl>
        </a>
    }, {
        key: 'PERSONAL_INFO_PROFILE',
        title: intl.get('Menu.SalesPERSONAL_INFO'),
        icon: IconMap['PERSONAL_INFO_PROFILE'],
        path: '/personal/info/profile'
    }].concat([
        {
            key: 'SETTING_SIGN_OUT',
            path: '',
            title: <a onClick={(e: any) => signOut()}>
                <Icon className={`anticon-${IconMap['SETTING_SIGN_OUT']}`} />
                <span>{intl.get('Global.SignOut')}</span>
            </a>
        }
    ])
});
